import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const GestionCanjesDenarios = ({ user }) => {
  const API = `${window.location.origin}/api`;
  const [planes, setPlanes] = useState([]);
  const [canjesRealizados, setCanjesRealizados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [planActual, setPlanActual] = useState(null);
  const [clases, setClases] = useState([]);
  const [activeTab, setActiveTab] = useState('planes'); // 'planes' o 'canjes'

  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    costo_denarios: '',
    beneficio: '',
    categoria: 'Académico',
    activo: true,
    icono: '🎁',
    requiere_seleccion_clase: false,
    clases_permitidas: [],
    url_recurso: ''  // URL para materiales digitales
  });

  useEffect(() => {
    loadPlanes();
    loadCanjesRealizados();
    if (user.rol === 'admin' || user.rol === 'profesor') {
      loadClases();
    }
  }, []);

  const loadClases = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await axios.get(`${API}/clases`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      // El endpoint devuelve directamente un array, no un objeto con propiedad 'clases'
      const clasesData = Array.isArray(response.data) ? response.data : [];
      console.log('Clases cargadas:', clasesData.length);
      console.log('Usuario rol:', user.rol, 'Usuario ID:', user.id);
      
      // Guardar todas las clases - el filtro se aplicará en el render
      setClases(clasesData);
    } catch (error) {
      console.error('Error loading clases:', error);
      toast.error('Error al cargar clases');
    }
  };

  const loadPlanes = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('access_token');
      const response = await axios.get(`${API}/admin/planes-canje`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPlanes(response.data.planes || []);
    } catch (error) {
      console.error('Error loading planes:', error);
      toast.error('Error al cargar planes de canje');
    } finally {
      setLoading(false);
    }
  };

  const loadCanjesRealizados = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await axios.get(`${API}/admin/canjes-realizados`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCanjesRealizados(response.data.canjes || []);
    } catch (error) {
      console.error('Error loading canjes:', error);
    }
  };

  const openCreateModal = async () => {
    setModoEdicion(false);
    setPlanActual(null);
    setFormData({
      nombre: '',
      descripcion: '',
      costo_denarios: '',
      beneficio: '',
      categoria: 'Académico',
      activo: true,
      icono: '🎁',
      requiere_seleccion_clase: false,
      clases_permitidas: []
    });
    setShowModal(true);
    // Cargar clases después de abrir el modal
    await loadClases();
  };

  const openEditModal = async (plan) => {
    setModoEdicion(true);
    setPlanActual(plan);
    setFormData({
      nombre: plan.nombre,
      descripcion: plan.descripcion,
      costo_denarios: plan.costo_denarios,
      beneficio: plan.beneficio,
      categoria: plan.categoria,
      activo: plan.activo,
      icono: plan.icono || '🎁',
      requiere_seleccion_clase: plan.requiere_seleccion_clase || false,
      clases_permitidas: plan.clases_permitidas || []
    });
    setShowModal(true);
    // Cargar clases después de abrir el modal
    await loadClases();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nombre || !formData.descripcion || !formData.costo_denarios || !formData.beneficio) {
      toast.error('Por favor completa todos los campos obligatorios');
      return;
    }

    try {
      const token = localStorage.getItem('access_token');
      const payload = {
        ...formData,
        costo_denarios: parseInt(formData.costo_denarios)
      };

      if (modoEdicion && planActual) {
        await axios.put(`${API}/admin/planes-canje/${planActual.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success('Plan actualizado exitosamente');
      } else {
        await axios.post(`${API}/admin/planes-canje`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success('Plan creado exitosamente');
      }

      setShowModal(false);
      loadPlanes();
    } catch (error) {
      console.error('Error saving plan:', error);
      toast.error(error.response?.data?.detail || 'Error al guardar plan');
    }
  };

  const handleDelete = async (planId) => {
    if (!window.confirm('¿Estás seguro de eliminar este plan de canje?')) {
      return;
    }

    try {
      const token = localStorage.getItem('access_token');
      await axios.delete(`${API}/admin/planes-canje/${planId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Plan eliminado exitosamente');
      loadPlanes();
    } catch (error) {
      console.error('Error deleting plan:', error);
      toast.error(error.response?.data?.detail || 'Error al eliminar plan');
    }
  };

  const handleClaseToggle = (claseId) => {
    setFormData(prev => {
      const clases = prev.clases_permitidas || [];
      if (clases.includes(claseId)) {
        return {
          ...prev,
          clases_permitidas: clases.filter(id => id !== claseId)
        };
      } else {
        return {
          ...prev,
          clases_permitidas: [...clases, claseId]
        };
      }
    });
  };

  const formatFecha = (fecha) => {
    if (!fecha) return 'N/A';
    const date = new Date(fecha);
    return date.toLocaleDateString('es-UY', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Filtrar clases según el rol del usuario
  const clasesDisponibles = user.rol === 'admin' 
    ? clases 
    : clases.filter(c => c.profesor_id === user.id);

  return (
    <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-8">
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2 flex items-center">
          <span className="text-3xl sm:text-4xl mr-3">🎁</span>
          Gestión de Canjes de Denarios
        </h2>
        <p className="text-sm sm:text-base text-gray-600">
          {user.rol === 'admin' 
            ? 'Crea y gestiona planes de canje para todas las clases'
            : 'Crea y gestiona planes de canje para tus clases'}
        </p>
      </div>

      {/* Tabs */}
      <div className="flex gap-4 mb-6 border-b border-gray-200">
        <button
          onClick={() => setActiveTab('planes')}
          className={`px-4 py-2 font-semibold transition-all ${
            activeTab === 'planes'
              ? 'text-indigo-600 border-b-2 border-indigo-600'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          📋 Planes de Canje
        </button>
        <button
          onClick={() => setActiveTab('canjes')}
          className={`px-4 py-2 font-semibold transition-all ${
            activeTab === 'canjes'
              ? 'text-indigo-600 border-b-2 border-indigo-600'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          📦 Canjes Realizados ({canjesRealizados.length})
        </button>
      </div>

      {/* Tab: Planes de Canje */}
      {activeTab === 'planes' && (
        <>
          <button
            onClick={openCreateModal}
            className="mb-6 px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all"
          >
            + Nuevo Plan de Canje
          </button>

          {loading ? (
            <div className="text-center py-12">
              <div className="text-xl text-gray-600">Cargando...</div>
            </div>
          ) : planes.length === 0 ? (
            <div className="text-center py-12">
              <div className="text-6xl mb-4">🎁</div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                No hay planes de canje creados
              </h3>
              <p className="text-gray-500">
                Crea tu primer plan de canje para que los estudiantes puedan canjear sus denarios
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {planes.map(plan => (
                <div
                  key={plan.id}
                  className={`border-2 rounded-xl p-6 ${
                    plan.activo ? 'border-green-200 bg-green-50' : 'border-gray-300 bg-gray-50'
                  }`}
                >
                  <div className="flex items-start justify-between mb-4">
                    <div className="text-4xl">{plan.icono}</div>
                    <div className="flex gap-2">
                      {plan.activo ? (
                        <span className="px-2 py-1 bg-green-500 text-white text-xs rounded-full">
                          Activo
                        </span>
                      ) : (
                        <span className="px-2 py-1 bg-gray-500 text-white text-xs rounded-full">
                          Inactivo
                        </span>
                      )}
                    </div>
                  </div>

                  <h3 className="text-lg font-bold text-gray-800 mb-2">{plan.nombre}</h3>
                  <p className="text-sm text-gray-600 mb-3">{plan.descripcion}</p>

                  <div className="bg-white rounded-lg p-3 mb-3">
                    <div className="text-xs text-gray-500 mb-1">Costo</div>
                    <div className="text-2xl font-bold text-indigo-600">{plan.costo_denarios} ₯</div>
                  </div>

                  <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-3">
                    <div className="text-xs text-gray-600 mb-1 font-semibold">Beneficio:</div>
                    <div className="text-sm text-gray-800">{plan.beneficio}</div>
                  </div>

                  <div className="flex gap-2 text-xs mb-3">
                    <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded-full">
                      {plan.categoria}
                    </span>
                    {plan.requiere_seleccion_clase && (
                      <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded-full">
                        Requiere clase
                      </span>
                    )}
                  </div>

                  <div className="text-xs text-gray-500 mb-4">
                    Creado por: {plan.created_by_name} ({plan.created_by_role})
                  </div>

                  <div className="flex gap-2">
                    <button
                      onClick={() => openEditModal(plan)}
                      className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-all text-sm"
                    >
                      Editar
                    </button>
                    <button
                      onClick={() => handleDelete(plan.id)}
                      className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition-all text-sm"
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* Tab: Canjes Realizados */}
      {activeTab === 'canjes' && (
        <div className="overflow-x-auto">
          {canjesRealizados.length === 0 ? (
            <div className="text-center py-12">
              <div className="text-6xl mb-4">📦</div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                No hay canjes realizados aún
              </h3>
              <p className="text-gray-500">
                Los canjes aparecerán aquí cuando los estudiantes canjeen sus denarios
              </p>
            </div>
          ) : (
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Estudiante
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Plan
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Beneficio
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Clase
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Costo
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Fecha
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Estado
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {canjesRealizados.map(canje => (
                  <tr key={canje.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-900">{canje.estudiante_nombre}</div>
                      <div className="text-xs text-gray-500">{canje.estudiante_email}</div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm font-semibold text-gray-900">{canje.plan_nombre}</div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm text-gray-600">{canje.plan_beneficio}</div>
                      {canje.mensaje_estudiante && (
                        <div className="mt-2 bg-yellow-50 border-l-4 border-yellow-400 p-2 rounded" data-testid={`mensaje-estudiante-${canje.id}`}>
                          <p className="text-xs text-yellow-900"><strong>💬 Mensaje del alumno:</strong></p>
                          <p className="text-xs text-yellow-800 mt-0.5 whitespace-pre-wrap">{canje.mensaje_estudiante}</p>
                        </div>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-600">
                        {canje.clase_seleccionada_nombre || 'N/A'}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-bold text-indigo-600">
                        {canje.costo_denarios} ₯
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-600">{formatFecha(canje.fecha_canje)}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full">
                        {canje.estado}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Modal Crear/Editar */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-gradient-to-r from-indigo-600 to-purple-600 p-6 rounded-t-2xl">
              <h3 className="text-2xl font-bold text-white">
                {modoEdicion ? '✏️ Editar Plan' : '➕ Nuevo Plan de Canje'}
              </h3>
            </div>

            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              {/* Nombre */}
              <div>
                <label className="block text-gray-700 font-semibold mb-2">
                  Nombre del Plan *
                </label>
                <input
                  type="text"
                  value={formData.nombre}
                  onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-indigo-600 focus:outline-none"
                  placeholder="Ej: Puntos Extra en Examen"
                  required
                />
              </div>

              {/* Descripción */}
              <div>
                <label className="block text-gray-700 font-semibold mb-2">
                  Descripción *
                </label>
                <textarea
                  value={formData.descripcion}
                  onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-indigo-600 focus:outline-none"
                  rows="3"
                  placeholder="Describe el plan de canje..."
                  required
                />
              </div>

              {/* Costo y Categoría */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">
                    Costo en Denarios *
                  </label>
                  <input
                    type="number"
                    value={formData.costo_denarios}
                    onChange={(e) => setFormData({ ...formData, costo_denarios: e.target.value })}
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-indigo-600 focus:outline-none"
                    placeholder="100"
                    min="1"
                    required
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">
                    Categoría *
                  </label>
                  <select
                    value={formData.categoria}
                    onChange={(e) => setFormData({ ...formData, categoria: e.target.value })}
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-indigo-600 focus:outline-none"
                    required
                  >
                    <option value="Académico">Académico</option>
                    <option value="Material">Material</option>
                    <option value="Certificados">Certificados</option>
                    <option value="Privilegios">Privilegios</option>
                    <option value="Otros">Otros</option>
                  </select>
                </div>
              </div>

              {/* Beneficio */}
              <div>
                <label className="block text-gray-700 font-semibold mb-2">
                  Beneficio *
                </label>
                <textarea
                  value={formData.beneficio}
                  onChange={(e) => setFormData({ ...formData, beneficio: e.target.value })}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-indigo-600 focus:outline-none"
                  rows="2"
                  placeholder="Ej: +5 puntos en el examen de la clase que elijas"
                  required
                />
              </div>

              {/* URL del Recurso (solo para Material Digital) */}
              {formData.categoria === 'Material' && (
                <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4">
                  <label className="block text-gray-700 font-semibold mb-2 flex items-center">
                    <span className="text-xl mr-2">🔗</span>
                    URL del Recurso Digital
                  </label>
                  <input
                    type="url"
                    value={formData.url_recurso}
                    onChange={(e) => setFormData({ ...formData, url_recurso: e.target.value })}
                    className="w-full px-4 py-3 border-2 border-green-300 rounded-lg focus:border-green-600 focus:outline-none"
                    placeholder="https://drive.google.com/file/... o https://ejemplo.com/ebook.pdf"
                  />
                  <p className="text-xs text-gray-600 mt-2">
                    💡 Ingresa el link de descarga del eBook, PDF o recurso digital. Los estudiantes podrán acceder a este link después de canjear.
                  </p>
                </div>
              )}

              {/* Icono y Estado */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">
                    Icono (Emoji)
                  </label>
                  <input
                    type="text"
                    value={formData.icono}
                    onChange={(e) => setFormData({ ...formData, icono: e.target.value })}
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-indigo-600 focus:outline-none text-2xl text-center"
                    placeholder="🎁"
                    maxLength="2"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">
                    Estado
                  </label>
                  <div className="flex items-center h-full">
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.activo}
                        onChange={(e) => setFormData({ ...formData, activo: e.target.checked })}
                        className="mr-2 w-5 h-5"
                      />
                      <span className="text-gray-700">Plan Activo</span>
                    </label>
                  </div>
                </div>
              </div>

              {/* Requiere Selección de Clase */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <label className="flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData.requiere_seleccion_clase}
                    onChange={(e) => setFormData({ 
                      ...formData, 
                      requiere_seleccion_clase: e.target.checked,
                      clases_permitidas: e.target.checked ? formData.clases_permitidas : []
                    })}
                    className="mr-3 w-5 h-5"
                  />
                  <div>
                    <span className="text-gray-700 font-semibold">
                      ¿Requiere selección de clase?
                    </span>
                    <p className="text-xs text-gray-600 mt-1">
                      Activa esto si el beneficio debe aplicarse a una clase específica (ej: puntos extra)
                    </p>
                  </div>
                </label>
              </div>

              {/* Selección de Clases Permitidas */}
              {formData.requiere_seleccion_clase && (
                <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                  <label className="block text-gray-700 font-semibold mb-3">
                    Clases Permitidas {user.rol === 'profesor' && '(Solo tus clases)'}
                  </label>
                  {clasesDisponibles.length === 0 ? (
                    <p className="text-sm text-gray-600">
                      {user.rol === 'profesor' 
                        ? 'No tienes clases asignadas como profesor'
                        : 'No hay clases disponibles'}
                    </p>
                  ) : (
                    <div className="space-y-2 max-h-40 overflow-y-auto">
                      {clasesDisponibles.map(clase => (
                        <label key={clase.id} className="flex items-center cursor-pointer hover:bg-purple-100 p-2 rounded">
                          <input
                            type="checkbox"
                            checked={formData.clases_permitidas.includes(clase.id)}
                            onChange={() => handleClaseToggle(clase.id)}
                            className="mr-3 w-4 h-4"
                          />
                          <span className="text-sm text-gray-700">{clase.titulo}</span>
                        </label>
                      ))}
                    </div>
                  )}
                  {formData.clases_permitidas.length === 0 && clasesDisponibles.length > 0 && (
                    <p className="text-xs text-gray-500 mt-2">
                      Si no seleccionas ninguna clase, el estudiante podrá elegir cualquier clase
                    </p>
                  )}
                </div>
              )}

              {/* Botones */}
              <div className="flex gap-4 pt-4">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="flex-1 px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-xl font-semibold hover:bg-gray-100 transition-all"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="flex-1 px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all"
                >
                  {modoEdicion ? 'Actualizar' : 'Crear Plan'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default GestionCanjesDenarios;
